import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import homeReducer from '../features/home/redux/reducer';
import commonReducer from '../features/common/redux/reducer';
import schoolClassesReducer from '../features/school-classes/redux/reducer';
import accessReducer from '../features/access/redux/reducer';
import productsReducer from '../features/products/redux/reducer';
import eventsReducer from '../features/events/redux/reducer';

// NOTE 1: DO NOT CHANGE the 'reducerMap' name and the declaration pattern.
// This is used for Rekit cmds to register new features, remove features, etc.
// NOTE 2: always use the camel case of the feature folder name as the store branch name
// So that it's easy for others to understand it and Rekit could manage them.

const reducerMap = {
  router: routerReducer,
  home: homeReducer,
  common: commonReducer,
  schoolClasses: schoolClassesReducer,
  access: accessReducer,
  products: productsReducer,
  events: eventsReducer,
};

export default combineReducers(reducerMap);



// WEBPACK FOOTER //
// ./src/common/rootReducer.js